<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1
      class="text-2xl font-bold textError"
      i18n="@@adminSidebarCreatePartiallyDeliveredReason">
      Create Partially Delivered Reason
    </h1>
  </div>
</div>
<div class="mb-4 rounded-2xl p-[16px]">
<form
  [formGroup]="reasonForm"
  (ngSubmit)="submitForm()"
  class="flex flex-col gap-6"
>
  <div class="rounded-2xl bg-white p-6 shadow-sm">

    <div class="grid grid-cols-2 gap-4">

      <!-- Arabic -->
      <div
        class="flex flex-col gap-2"
        dir="rtl"
      >
        <app-filter-input
          [label]="titleArLabel"
          [required]="true"
          [placeholder]="titleArPlaceholder"
          [value]="titleAr()"
          (valueChange)="onArabicChange($event)"
          [isInvalid]="
            titleArControl().invalid &&
            titleArControl().touched
          "
        />

        @if (titleArControl().invalid && titleArControl().touched) {
          <span class="textError text-[12px]">

            @if (titleArControl().errors?.['arabicOnly']) {
              <span i18n="@@partiallyDeliveredReasonArabicOnly">
                Reason Title (Arabic) must contain Arabic letters only
              </span>

            } @else if (titleArControl().errors?.['spaces']) {
              <span i18n="@@partiallyDeliveredReasonArabicSpaces">
                Arabic Reason title cannot start or end with spaces
              </span>

            } @else if (titleArControl().errors?.['numbers']) {
              <span i18n="@@partiallyDeliveredReasonArabicNumbers">
                Reason Name cannot contain numbers
              </span>

            } @else if (titleArControl().errors?.['minlength']) {
              <span i18n="@@partiallyDeliveredReasonArabicMinLength">
                Reason Name must be at least 3 characters
              </span>

            } @else if (titleArControl().errors?.['maxlength']) {
              <span i18n="@@partiallyDeliveredReasonArabicMaxLength">
                Reason Name cannot exceed 255 characters
              </span>

            } @else if (titleArControl().errors?.['required']) {
              <span i18n="@@partiallyDeliveredReasonArabicRequired">
                Reason Name in Arabic is required
              </span>
            }

          </span>
        }
      </div>

      <!-- English -->
      <div class="flex flex-col gap-2">

        <app-filter-input
          [label]="titleEnLabel"
          [placeholder]="titleEnPlaceholder"
          [value]="titleEn()"
          (valueChange)="onEnglishChange($event)"
          [isInvalid]="
            titleEnControl().invalid &&
            titleEnControl().touched
          "
        />

        @if (titleEnControl().invalid && titleEnControl().touched) {
          <span class="textError text-[12px]">

            @if (titleEnControl().errors?.['englishOnly']) {
              <span i18n="@@partiallyDeliveredReasonEnglishOnly">
                Reason Title (English) must contain English letters only
              </span>

            } @else if (titleEnControl().errors?.['spaces']) {
              <span i18n="@@partiallyDeliveredReasonEnglishSpaces">
                English Reason title cannot start or end with spaces
              </span>

            } @else if (titleEnControl().errors?.['numbers']) {
              <span i18n="@@partiallyDeliveredReasonEnglishNumbers">
                Reason Name cannot contain numbers
              </span>

            } @else if (titleEnControl().errors?.['minlength']) {
              <span i18n="@@partiallyDeliveredReasonEnglishMinLength">
                Reason Name must be at least 3 characters
              </span>

            } @else if (titleEnControl().errors?.['maxlength']) {
              <span i18n="@@partiallyDeliveredReasonEnglishMaxLength">
                Reason Name cannot exceed 255 characters
              </span>
            }

          </span>
        }

      </div>

    </div>

    <div class="mt-10 flex justify-end gap-3">

      <app-submit-button
        class="hover:cursor-pointer"
        type="secondary"
        (click)="cancel()"
      >
        {{ cancelButton }}
      </app-submit-button>

      <app-submit-button
        class="hover:cursor-pointer"
        type="primary"
      >
        {{ submitButton }}
      </app-submit-button>

    </div>

  </div>
</form>


</div>

@if (showConfirmation()) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="confirmationTitle"
    [description]="confirmationDescription"
    [error]="errorMessage()"
    [confirmContent]="confirmButton()"
    [cancelContent]="cancelButton"
    (onSubmit)="confirmCreate()"
    (onCancel)="closeConfirmation()"
  />
}


@if (successMessage()) {
  <app-successful-notification
    type="success"
    [title]="successMessage()!"
  />
}